import type { IWorkflowListResponse, IWorkflowResponse } from '@escloud/types';

import type { ApiClient } from './api-client';

export class WorkflowsService {
    constructor(private api: ApiClient) {}

    list(): Promise<IWorkflowListResponse> {
        return this.api.get<IWorkflowListResponse>('/workflows');
    }

    getById(id: string): Promise<IWorkflowResponse> {
        return this.api.get<IWorkflowResponse>(`/workflows/${id}`);
    }
}
